import maso from '@/assets/masso.png';

interface IconProps {
  width?: string;
  height?: string;
  className?: string;
  alt?: string;
}

function Masso({
  width = '200',
  height = '70',
  className = '',
  alt = 'Maso',
}: IconProps) {
  return (
    <img
      src={maso}
      alt={alt}
      width={width}
      height={height}
      className={className}
    />
  );
}

export default Masso;
